/**
 * Created by sshu on 2020/4/1
 */
import * as API from '@/service/index'
//各校数据展板及总数据展板

//获取主页数据集合
export const findSchoolData = (params) => {
    return API.GET('/stats/portal/getSchoolData', params)
}
//获取各校的年级列表
export const findGradeList = (params) => {
    return API.GET('/stats/homeworks/schema/grades', params)
}
export const getSchoolGrade = (params) => {
    return API.GET('/userMgr/basegrade/getSchoolGrade', params)
}
// 获取各校的学科列表
export const findSubjectsList = (params) => {
    return API.GET("/stats/homeworks/schema/subjects", params)
}
// 获取各校的班级列表
export const findClassesList = (params) => {
    return API.GET("/stats/homeworks/schema/classes", params)
}
// 获取学年列表
export const findSchoolYears = (params) => {
    return API.GET("/stats/homeworks/schema/schoolyears", params)
}
// 获取学年列表
export const getSchoolYearList = (params) => {
    return API.GET("/userMgr/baseschool/getSchoolYearList", params)
}
// 获取省市区
export const findRegion = (params) => {
    return API.GET("/userMgr/baseregion/getRegion", params)
}
// 获取总数据展板的班级教师学生的列表数据
export const findTotalBySchool = (params) => {
    return API.GET("/stats/bigscreenusage/getTotalBySchool", params)
}
// 获取总数据展板的作业资源微课的列表数据
export const findTotalDataBySchool = (params) => {
    return API.GET("/stats/bigscreenusage/getTotalBySchool/summary", params)
}

//[作业]——获取年级活跃情况
export const findHomeworkActiveGrade = (params) => {
    return API.GET('/stats/homeworks/activity/grades/list', params)
}

//[作业]——获取班级活跃情况
export const findHomeworkActiveClass = (params) => {
    return API.GET('/stats/homeworks/activity/classes/list', params)
}

//[作业]——获取教师活跃情况
export const findHomeworkActiveTeacher = (params) => {
    return API.GET('/stats/homeworks/activity/teachers/list', params)
}
// [作业]——J教师活跃数据概览
export const findHomeworkTeachersSummary = (params) => {
    return API.GET("/stats/homeworks/teachers/summary", params)
}
// [作业]——数据概览
export const findHomeworkSummary = (params) => {
    return API.GET("/stats/homeworks/class/summary", params)
}
// [作业]-班级详情列表
export const findClassHwDetail = (params) => {
    return API.GET("/stats/homeworks/class/detail", params)
}
// [作业]-教师详情列表
export const findTeacherHwDetail = (params) => {
    return API.GET("/stats/homeworks/teacher/detail", params)
}

// [作业]-年级详情列表
export const findGradeHwDetail = (params) => {
    return API.GET("/stats/homeworks/grades/detail", params)
}

//[微课]——获取教师活跃情况
export const findMicroActiveTeacher = (params) => {
    return API.GET('/stats/microclass/activity/teachers', params)
}
//[微课]——获取班级活跃情况
export const findMicroActiveClass = (params) => {
    return API.GET('/stats/microclass/activity/classes', params)
}
//[微课]——获取年级活跃情况
export const findMicroActiveGrade = (params) => {
    return API.GET('/stats/microclass/activity/grades', params)
}
//[微课]-数据概览
export const findMicroSummary = (params) => {
    return API.GET('/stats/microclass/grades/summary', params)
}
//[微课]-教师数据概览
export const findMicroTeachersSummary = (params) => {
    return API.GET('/stats/microclass/teachers/summary', params)
}

//[微课]——年级详情列表
export const findGradeMicroDetail = (params) => {
    return API.GET('/stats/microclass/grades/list', params)
}

//[微课]——班级详情列表
export const findClassMicroDetail = (params) => {
    return API.GET('/stats/microclass/classes/list', params)
}

//[微课]——教师详情列表
export const findTeacherMicroDetail = (params) => {
    return API.GET('/stats/microclass/teachers/list', params)
}
//[资源]——获取教师活跃情况
export const findResourceActiveTeacher = (params) => {
    return API.GET('/stats/resource/teachers/ranking', params)
}
//[资源]——获取班级活跃情况
export const findResourceActiveClass = (params) => {
    return API.GET('/stats/resource/classes/ranking', params)
}
//[资源]——获取年级活跃情况
export const findResourceActiveGrade = (params) => {
    return API.GET('/stats/resource/grades/ranking', params)
}
//[资源]-数据概览
export const findResourceSummary = (params) => {
    return API.GET('/stats/resource/grades/summary', params)
}
//[资源]-教师数据概览
export const findResourceTeachersSummary = (params) => {
    return API.GET('/stats/resource/teachers/summary', params)
}

//[资源]——年级详情列表
export const findGradeResourceDetail = (params) => {
    return API.GET('/stats/resource/grades/list', params)
}

//[资源]——班级详情列表
export const findClassResourceDetail = (params) => {
    return API.GET('/stats/resource/classes/list', params)
}

//[资源]——教师详情列表
export const findTeacherResourceDetail = (params) => {
    return API.GET('/stats/resource/teachers/list', params)
}

//[探究学习]——获取教师活跃情况
export const findLearningActiveTeacher = (params) => {
    return API.GET('/stats/inquirystudy/teachers/summary/ranking', params)
}
//[探究学习]——获取班级活跃情况
export const findLearningActiveClass = (params) => {
    return API.GET('/stats/inquirystudy/classes/summary/ranking', params)
}
//[探究学习]——获取年级活跃情况
export const findLearningActiveGrade = (params) => {
    return API.GET('/stats/inquirystudy/grades/summary/ranking', params)
}

//[探究学习]-数据概览
export const findLearningSummary = (params) => {
    return API.GET('/stats/inquirystudy/grades/summary', params)
}
//[探究学习]-教师数据概览
export const findLearningTeachersSummary = (params) => {
    return API.GET('/stats/inquirystudy/teachers/summary', params)
}

//[探究学习]——年级详情列表
export const findGradeLearningDetail = (params) => {
    return API.GET('/stats/inquirystudy/grades/list', params)
}

//[探究学习]——班级详情列表
export const findClassLearningDetail = (params) => {
    return API.GET('/stats/inquirystudy/classes/list', params)
}

//[探究学习]——教师详情列表
export const findTeacherLearningDetail = (params) => {
    return API.GET('/stats/inquirystudy/teachers/list', params)
}

//[互动答疑]——获取教师活跃情况
export const findInteractActiveTeacher = (params) => {
    return API.GET('/stats/interact/teachers/ranking', params)
}
//[互动答疑]——获取班级活跃情况
export const findInteractActiveClass = (params) => {
    return API.GET('/stats/interact/classes/ranking', params)
}
//[互动答疑]——获取年级活跃情况
export const findInteractActiveGrade = (params) => {
    return API.GET('/stats/interact/grades/ranking', params)
}

//[互动答疑]-数据概览
export const findInteractSummary = (params) => {
    return API.GET('/stats/interact/grades/summary', params)
}
//[互动答疑]-教师数据概览
export const findInteractTeachersSummary = (params) => {
    return API.GET('/stats/interact/teachers/summary', params)
}

//[互动答疑]——年级详情
export const findGradeInteractDetail = (params) => {
    return API.GET('/stats/interact/grades/list', params)
}
//[互动答疑]——班级详情
export const findClassInteractDetail = (params) => {
    return API.GET('/stats/interact/classes/list', params)
}
//[互动答疑]——教师详情
export const findTeaInteractDetail = (params) => {
    return API.GET('/stats/interact/teachers/list', params)
}

//[作业]——教师统计详情页 统计指标
export const findTeacherSummary = (params) => {
    return API.GET('/stats/homeworks/teacher/summary', params)
}

//作业——获取教师布置作业中不同类型作业的占比
export const findTeacherHwTypeStatic = (params) => {
    return API.GET('/stats/homeworks/teacher/compare/type', params)
}

//作业——获取教师每天部署作业数
export const findTeacherHwNumDayList = (params) => {
    return API.GET('/stats/homeworks/teacher/trend/day', params)
}

//作业——教师布置作业详情
export const findTeacherDetailList = (params) => {
    return API.GET('/stats/homeworks/teacher/detail/list', params)
}
//主页展板顶部横跨模块数据
export const findBoardTopData = (params) => {
    return API.GET('/stats/portal/summary', params)
}
//主页展板内页-资源列表
export const findResourceList = (params) => {
    return API.GET('/stats/resource/operation/list', params)
}
//主页展板内页-资源列表new
export const findResourceNewList = (params) => {
    return API.GET('/stats/resource/operation/getResourceList', params)
}
//上传的资源、微课数
export const findUploadResourceSummary = (params) => {
    return API.GET('/stats/resource/operation/getUploadResourceSummary', params)
}
//获取分享课件列表
export const findShareCoursewareList = (params) => {
    return API.GET('/stats/resource/operation/getShareCoursewareList', params)
}
//主页展板内页-资源数据概览
export const findResourceDataSummary = (params) => {
    return API.GET('/stats/resource/operation/summary', params)
}
//主页展板内页-微课列表
export const findMicroList = (params) => {
    return API.GET('/stats/microclass/operation/list', params)
}
//主页展板内页-微课数据概览
export const findMicroDataSummary = (params) => {
    return API.GET('/stats/microclass/operation/summary', params)
}
// 主页展板内页-作业数据概览
export const findHwDetail = (params) => {
    return API.GET("/stats/homeworks/grades/dashboard/detail", params)
}
//班级列表
export const findClassList = (params) => {
    return API.GET('/stats/bigscreenusage/classes/list', params)
}
//教师列表
export const findTeacherList = (params) => {
    return API.GET('/stats/bigscreenusage/teachers/list', params)
}
//学生列表
export const findStudentList = (params) => {
    return API.GET('/stats/bigscreenusage/students/list', params)
}
//教师列表数据详情
export const findUsageRecordByProduct = (params) => {
    return API.GET('/stats/bigscreenusage/getUsageRecordByProduct', params)
}
//获取教师学生行为分析数据
export const findUserActionAnalyseData = (params) => {
    return API.GET('/stats/behavior/user', params)
}
//获取教师学生行为分析详情数据
export const findUserActionAnalyseDetails = (params) => {
    return API.GET('/stats/behavior/user/list', params)
}

//区域数据展板

//区域数据展板横框数据
export const findSummaryByAgent = (params) => {
    return API.GET('/stats/bigscreenusage/getSummaryByAgent', params)
}
//区域数据展板学段
export const findSummaryByPhase = (params) => {
    return API.GET('/stats/bigscreenusage/getSummaryByPhase', params)
}
//区域数据展板学校top5统计
export const findSummaryBySchool = (params) => {
    return API.GET('/stats/bigscreenusage/getSummaryBySchool', params)
}
//区域数据展板学科top5统计
export const findSummaryBySubject = (params) => {
    return API.GET('/stats/bigscreenusage/getSummaryBySubject', params)
}
//区域数据展板学段数据概览
export const findPhaseDataSummary = (params) => {
    return API.GET('/stats/bigscreenusage/getActiveByPhaseList/summary', params)
}
//区域数据展板学段列表数据
export const findActiveByPhaseList = (params) => {
    return API.GET('/stats/bigscreenusage/getActiveByPhaseList', params)
}
//区域数据展板学校数据概览
export const findSchoolDataSummary = (params) => {
    return API.GET('/stats/bigscreenusage/getActiveBySchoolList/summary', params)
}
//区域数据展板学校列表数据
export const findActiveBySchoolList = (params) => {
    return API.GET('/stats/bigscreenusage/getActiveBySchoolList', params)
}
//区域数据展板学科数据概览
export const findSubjectDataSummary = (params) => {
    return API.GET('/stats/bigscreenusage//getActiveBySubjectList/summary', params)
}
//区域数据展板学科数据概览
export const findActiveBySubjectList = (params) => {
    return API.GET('/stats/bigscreenusage/getActiveBySubjectList', params)
}
//区域数据展板横框模块概览
export const findTotalSchoolByAgentIdSummary = (params) => {
    return API.GET('/stats/bigscreenusage/getTotalSchoolByAgentId/summary', params)
}
//区域数据展板横框列表数据
export const findTotalSchoolByAgentId = (params) => {
    return API.GET('/stats/bigscreenusage/getTotalSchoolByAgentId', params)
}
//区域数据展板总数据
export const findRegionData = (params) => {
    return API.GET('/stats/portal/getSchoolData', params)
}
//区域用户行为分析
export const regionUserActionData = (params) => {
    return API.GET('/stats/behavior/user/agent', params)
}
//区域用户行为详情分析
export const regionUserActionDetailsData = (params) => {
    return API.GET('/stats/behavior/user/agent/list', params)
}
//作业类型列表(根据学校id区分小学和中学学段)
export const findHwTypeCodeList = (params) => {
    return API.GET('/stats/homeworks/getHwTypeCodeList', params)
}
//获取探究学习墙的数据
export const findInquiryList = (params) => {
    return API.GET('/stats/inquirystudy/operation/list', params)
}
//获取探究学习墙的数据
export const findInquirySummary = (params) => {
    return API.GET('/stats/inquirystudy/operation/summary', params)
}
// 课堂行为分析 (饼图)
export const fetchBehaviorData = (params) => {
    return API.GET('/stats/portal/getBehaviorData', params);
}
// 获取教师活跃情况(折线图)
export const fetchTeacherActiveData = (params) => {
    return API.GET('/stats/portal/getTeacherActiveData', params);
}
// 获取知识掌握数据
export const fetchKnowledgeMasterData = (params) => {
    return API.GET('/stats/portal/yiQi/getKnowledgeMasterData', params);
}
// 获取学科能力数据
export const fetchSubjectAbilityData = (params) => {
    return API.GET('/stats/portal/yiQi/getSubjectAbilityData', params);
}
// 获取作业统计详情
export const fetchHwData = (params) => {
    return API.GET('/stats/portal/yiQi/getHwData', params);
}
// 获取题目类型统计
export const getQueTypeStatAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getQueTypeStat', params);
}
// 获取教师答题互动统计
export const getInteractStatAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getInteractStat', params);
}
// 获取学校答题互动统计列表
export const getSchoolInteractStatListAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getSchoolInteractStatList', params);
}
// 获取教师答题互动统计列表
export const getInteractStatListAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getInteractStatList', params);
}
// 获取班级答题互动统计
export const getWholeStatAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getWholeStat', params);
}
// 获取班级答题互动统计列表
export const getClsListStatAPI = (params) => {
    return API.GET('/homeworkstatic/penpaper/getClsListStat', params);
}
//获取校评价数据
export const getSchoolEvaluateData = (params) => {
    return API.GET('/stats/evaluateAnalysis/getSchoolEvaluateData', params);
}
//学校产品使用日活趋势图
export const getSchoolDayActive = (params) => {
    return API.GET('/website/school/schoolDayActive', params);
}
//学校产品使用周活趋势图
export const getSchoolWeekActive = (params) => {
    return API.GET('/website/school/schoolWeekActive', params);
}
//学校产品使用月活趋势图
export const getSchoolMonthActive = (params) => {
    return API.GET('/website/school/schoolMonthActive', params);
}
//获取教师评价榜
export const getTeaEvaluateTop = (params) => {
    return API.GET('/screen/evalDataDisplay/getTeaEvaluateTop', params);
}
//查询学校教师资源统计列表
export const getTeaResStat = (params) => {
    return API.GET('/website/webSiteSchool/getTeaResStat', params);
}
// 未来教室展板API-获取用户活跃趋势列表
export const getUserActivityTrendApi = (params) => {
    return API.GET('/stats/portal/getUserActivityTrend', params)
}
// 未来教室展板API-教师教学近七天行为分析数据
export const getTeachingBehaviorDataApi = (params) => {
    return API.GET('/stats/portal/getTeaTargetBySchoolId', params)
}
// 未来教室展板API-根据学校ID获取年级列表
export const getGradeListBySchoolIdApi = (params) => {
    return API.GET('/userMgr/basegrade/getGradeListBySchoolId', params)
}
// 未来教室展板API-根据学校ID获取学科列表
export const getSubjectApi = (params) => {
    return API.GET('/userMgr/basesubject/getSubject', params)
}
// 未来教室展板API-根据学校ID获取绑定大屏的班级列表
export const getScreenBindClassBySchoolIdApi = (params) => {
    return API.GET('/stats/portal/getScreenBindClassBySchoolId', params)
}
// 未来教室展板API-根据学校ID与班级Id获取课表
export const getClassCourseTableListApi = (params) => {
    return API.GET('/userMgr/baseclass/getClassCourseTableList', params)
}
// 未来教室展板API-根据学校ID班级Id获取代课教师列表
export const getTeacherListByClassId = (params) => {
    return API.GET('/userMgr/baseclass/getTeacherListByClassId', params)
}
// 未来教室展板API-设置课表
export const setClassCourseTableApi = (params) => {
    return API.POST('/userMgr/baseclass/setClassCourseTable', params)
}
// 未来教师展板API-删除课表
export const delClassCourseTableApi = (params) => {
    return API.POST('/userMgr/baseclass/delClassCourseTable', params)
}
// 未来教室展板API-今日课堂互动数据
export const getClassroomAnalysisDincDataApi = (params) => {
    return API.GET('/stats/portal/getClassroomAnalysisDincData', params)
}
// 未来教室展板API-课堂实景数据
export const getClassroomDynamicDincDataApi = (params) => {
    return API.GET('/stats/portal/getClassroomDynamicDincData', params)
}
// 未来教室展板API-获取配置中心学校所配置的状态
export const getPublicConfigBySchoolInfoApi = (params) => {
    return API.GET('/public/config/getPublicConfigBySchoolInfo', params)
}
// 未来教室展板API-获取学校课表设置状态
export const getClassCourseTableStateApi = (params) => {
    return API.GET('/userMgr/baseclass/getClassCourseTableState', params)
}
// 未来教室展板API-保存班级教室
export const saveClassRoomApi = (params) => {
    return API.POST('/userMgr/baseclass/saveClassRoom', params)
}
// 未来教室展板API-获取学校班级教室列表
export const getClassRoomListApi = (params) => {
    return API.GET('/userMgr/baseclass/getClassRoomList', params)
}
// 未来教师展板API-获取班级列表
export const getClassListApi = (params) => {
    return API.GET('/userMgr/baseclass/classList', params)
}
// 未来教师展板API-删除班级教室
export const delClassRoomApi = (params) => {
  return API.POST('/userMgr/baseclass/delClassRoom', params)
}